module.exports = __webpack_public_path__ + "img/undraw_group_chat.afbc31de.svg";